import { IconTelephone, useBreakpointValue } from '@gazin/ecommerce-ui'
import Link from 'src/components/Link'
import { useEffect, useState } from 'react'
import { useBlackFriday } from 'src/contexto/hooks/useBlackFriday'
import { usePaymentMethod } from 'src/contexto/hooks/usePaymentMethod'
import { useWindowDimensions } from 'src/contexto/hooks/useWindowDimensions'
import NewsletterSection from '../newsletterSection'
import SacHorariosAtendimento from '../sacHorariosAtendimento'
import SetorInformacao from '../setorInformacao'
import WhatsAppButton from '../whatsAppButton'
import {
  arePixOrBilletAvailable,
  getInCashAvailablePaymentMethods,
} from 'src/util/payment'
import { useGlobalContext } from 'src/contexto/contextoGlobal'
import { FooterSection, FooterContainer, SectionInfoPagamento } from './styles'
import AreaSecundaria from './areaSecundaria'

export default function Footer({
  showNewsletter = false,
  buttonColor = '',
  finalColor = '',
  initialColor = '',
  textColor = '',
}) {
  const [marginBottom, setMarginBottom] = useState(false)
  const { menuInstitucionalData, menuDuvidasData, sacInformation } =
    useGlobalContext()
  const { isBlackFridayTheme } = useBlackFriday()
  const { width } = useWindowDimensions()
  const { payment } = usePaymentMethod()

  useEffect(() => {
    definirMargemInferior()
  }, [])

  const isMobile = Boolean(
    useBreakpointValue({ base: true, sm: true, md: false })
  )

  function definirMargemInferior() {
    const barraFixa = document.querySelector('.barra-fixa')
    if (barraFixa) return setMarginBottom(true)
  }

  return (
    <>
      {showNewsletter && (
        <NewsletterSection
          initialColor={initialColor}
          finalColor={finalColor}
          background={true}
          buttonColor={buttonColor}
          textColor={textColor}
        />
      )}

      {isMobile && <SetorInformacao darkTheme={isBlackFridayTheme} />}

      <FooterSection id="footer" darkTheme={isBlackFridayTheme}>
        <FooterContainer marginBottom={marginBottom}>
          <div className="area-primaria">
            <div className="esq">
              <div
                className="atendimento"
                data-testid="footer-sac-area"
              >
                <IconTelephone width="2.3125rem" height="2rem" />
                <div className="info">
                  <span>Atendimento</span>
                  <a
                    href={`tel:${sacInformation?.telefone}`}
                    as={`tel:${sacInformation?.telefone}`}
                  >
                    {sacInformation?.telefone}
                  </a>
                  <SacHorariosAtendimento
                    horarioAtendimentoDiasUteisInicio={
                      sacInformation?.horario_atendimento_dias_uteis_inicio
                    }
                    horarioAtendimentoDiasUteisFim={
                      sacInformation?.horario_atendimento_dias_uteis_fim
                    }
                    horarioAtendimentoSabadoInicio={
                      sacInformation?.horario_atendimento_sabado_inicio
                    }
                    horarioAtendimentoSabadoFim={
                      sacInformation?.horario_atendimento_sabado_fim
                    }
                    horarioAtendimentoDomingoInicio={
                      sacInformation?.horario_atendimento_domingo_inicio
                    }
                    horarioAtendimentoDomingoFim={
                      sacInformation?.horario_atendimento_domingo_fim
                    }
                  ></SacHorariosAtendimento>
                  <div className="canal-whatsapp">
                    <WhatsAppButton />
                  </div>
                </div>
              </div>
            </div>
            <nav>
              {menuInstitucionalData?.itens ? (
                <div
                  className="item itemInstitucional"
                  data-testid="footer-institutional-area"
                >
                  {/*
                    TNDC-328: era <h3>. Item de navegacao do rodape nao e
                    estrutura de conteudo, e contribuia para o <h1> da pagina
                    ficar em 44o lugar no sumario do documento.
                  */}
                  <div className="titulo-rodape" id="rodape-institucional">
                    Institucional
                  </div>
                  <ul aria-labelledby="rodape-institucional">
                    {menuInstitucionalData?.itens.map((item) => {
                      return (
                        <li key={item.id}>
                          {item.parametros.target ? (
                            <a
                              href={item.parametros.url}
                              target={item.parametros.target}
                            >
                              {item.nome}
                            </a>
                          ) : (
                            <Link href={item.parametros.url}>{item.nome}</Link>
                          )}
                        </li>
                      )
                    })}
                  </ul>
                </div>
              ) : (
                ''
              )}
              {menuDuvidasData ? (
                <>
                  <div
                    className="item itemDuvidas"
                    data-testid="footer-questions-area"
                  >
                    {/* TNDC-328: era <h3>, mesmo motivo. */}
                    <div className="titulo-rodape" id="rodape-duvidas">
                      Dúvidas
                    </div>
                    <ul aria-labelledby="rodape-duvidas">
                      {menuDuvidasData?.itens?.map((item, key) => {
                        return key < 5 ? (
                          <li key={item.id}>
                            {item.chave_tipo === 'pagina' ? (
                              <Link
                                href="/pagina/[...pagina]"
                                as={`/pagina/${item.parametros.pagina_slug}`}
                                target={
                                  item.parametros.target
                                    ? item.parametros.target
                                    : ''
                                }
                              >
                                {item.nome}
                              </Link>
                            ) : (
                              <a
                                href={item.parametros.url}
                                target={
                                  item.parametros.target
                                    ? item.parametros.target
                                    : ''
                                }
                              >
                                {item.nome}
                              </a>
                            )}
                          </li>
                        ) : null
                      })}
                    </ul>
                  </div>

                  <div className="item itemDuvidasMenu">
                    {/*
                      TNDC-328: era <h3>&nbsp;</h3> — um cabecalho VAZIO usado
                      so para alinhar a segunda coluna de links. Alinhamento e
                      trabalho de CSS; no sumario isso aparecia como secao sem
                      titulo. Mantido como espacador, fora da arvore de
                      acessibilidade.
                    */}
                    <div aria-hidden="true" className="titulo-rodape">
                      &nbsp;
                    </div>
                    <ul>
                      {menuDuvidasData?.itens?.map((item, key) => {
                        return key >= 5 ? (
                          <li key={item.id}>
                            {item.chave_tipo === 'pagina' ? (
                              <Link
                                href="/pagina/[...pagina]"
                                as={`/pagina/${item.parametros.pagina_slug}`}
                                target={
                                  item.parametros.target
                                    ? item.parametros.target
                                    : ''
                                }
                              >
                                {item.nome}
                              </Link>
                            ) : (
                              <a
                                href={item.parametros.url}
                                target={
                                  item.parametros.target
                                    ? item.parametros.target
                                    : ''
                                }
                              >
                                {item.nome}
                              </a>
                            )}
                          </li>
                        ) : null
                      })}
                    </ul>
                  </div>
                </>
              ) : (
                ''
              )}
            </nav>
          </div>
          <AreaSecundaria />
        </FooterContainer>
      </FooterSection>
    </>
  )
}
